<template>
  <section class="content-menu-tasks">
    <Breadcrumb
      :links="links"
      :data="{ name: 'Tarefa', id: this.currentTask.id }"
    />
    <div class="content-menu-tasks-body">
      <a @click="editTask()" class="content-menu-tasks-body--link">
        <p>Editar Tarefa</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </a>
      <a @click="registerContents()" class="content-menu-tasks-body--link">
        <p>Cadastrar Conteúdo</p>
        <div class="icon">
          <svg
            width="8"
            height="16"
            viewBox="0 0 8 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_20_670)">
              <mask
                id="mask0_20_670"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="1"
                width="8"
                height="15"
              >
                <path
                  d="M0.25 15.5L7.75 15.5L7.75 1.17984L0.25 1.17984L0.25 15.5Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_20_670)">
                <path
                  d="M7.4754 9.06207C7.84153 8.66266 7.84153 8.01398 7.4754 7.61457L1.85149 1.47936C1.48538 1.07995 0.89075 1.07995 0.524625 1.47936C0.158437 1.87884 0.158437 2.52745 0.524625 2.92693L5.48652 8.33989L0.527563 13.7529C0.161375 14.1523 0.161375 14.801 0.527563 15.2004C0.893688 15.5999 1.48831 15.5999 1.85442 15.2004L7.47832 9.06527L7.4754 9.06207Z"
                  fill="black"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_20_670">
                <path
                  d="M7.75 11.75C7.75 13.8211 6.07107 15.5 4 15.5C1.92893 15.5 0.25 13.8211 0.25 11.75L0.25 0.5L7.75 0.5L7.75 11.75Z"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </a>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "",
          routerName: "Tasks",
        },
        {
          name: "Menu",
          routerName: "MenuTasks",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Tasks", ["currentTask"]),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    editTask() {
      this.$router.push({
        name: "EditTask",
        params: {
          idTask: this.currentTask.id,
        },
      });
    },
    registerContents() {
      this.$router.push({ name: "RegisterContents" });
    },
  },
  async mounted() {
    let task = await this.currentTask;
    if (task && Object.keys(task).length > 0) {
      this.links[0].name = task.name;
    }
  },
};
</script>

<style lang="scss">
.content-menu-tasks {
  &-body {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 50px;
    &--link {
      width: calc(50% - 15px);
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--white);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      border-radius: 15px;
      padding: 0px 20px;
      margin-right: 15px;
      margin-bottom: 30px;
      transition: 500ms;
      &:nth-child(even) {
        margin-right: 0;
        margin-left: 15px;
      }
      @media (max-width: 767px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
        &:nth-child(even) {
          margin-left: 0;
        }
      }
      &:hover,
      &:focus {
        cursor: pointer;
        background: var(--yellow);
      }
      p {
        font-size: 20px;
        font-family: "Font Semibold";
        color: var(--black);
        margin-bottom: 0;
      }
      .icon {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--yellow);
        border-radius: 100%;
      }
    }
  }
}
</style>
